import React from 'react'
import { SvgIcon } from '@material-ui/core'

export default function NmkIcon() {
  return (
    <SvgIcon>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
      >
<g>
	<path d="M11.87,12.16c-0.35,0-0.63,0.29-0.64,0.64c0,0.36,0.29,0.65,0.63,0.64c0.35,0,0.64-0.3,0.63-0.65
		C12.5,12.45,12.21,12.16,11.87,12.16z"/>
	<path d="M0.64,9.27c0,1.83,0,3.66,0,5.5c7.59,0,15.17,0,22.76,0c0-1.84,0-3.67,0-5.51C23.27,9.25,0.73,9.25,0.64,9.27z M4.38,13.74
		c-0.14,0-0.27,0-0.41,0c0-1.16,0-2.31,0-3.47c0.14,0,0.27,0,0.41,0C4.38,11.43,4.38,12.58,4.38,13.74z M6.31,13.78
		c-0.61-0.57-1.21-1.14-1.82-1.72c0.57-0.61,1.14-1.22,1.72-1.84c0.1,0.09,0.18,0.17,0.28,0.25c-0.5,0.51-0.99,1.01-1.49,1.53
		c0.54,0.5,1.07,0.99,1.59,1.48C6.49,13.59,6.4,13.69,6.31,13.78z M10.22,13.6c-0.1,0.05-0.22,0.11-0.32,0.16
		c-0.74-0.96-1.47-1.92-2.21-2.87c-0.05,0.04-0.03,0.08-0.03,0.12c0,0.87,0.01,1.73,0.01,2.6c0,0.04,0,0.09,0,0.14
		c-0.13,0-0.26,0-0.39,0c0-1.11,0-2.21,0-3.32c0.12-0.06,0.24-0.12,0.38-0.18C8.38,11.17,9.1,12.08,9.81,13
		c0.01,0,0.02-0.01,0.03-0.01c0.01-0.9-0.02-1.81-0.02-2.72c0.14,0,0.26,0,0.39,0C10.22,11.38,10.22,12.48,10.22,13.6z M14.25,12.12
		c-0.11,0-0.21,0-0.33,0c-0.02-0.12-0.01-0.24-0.01-0.36c0-0.13,0-0.26,0-0.38c0-0.12,0-0.24,0-0.37C13.9,11,13.89,11,13.88,11
		c-0.4,0.41-0.8,0.82-1.21,1.23c0.17,0.27,0.22,0.56,0.13,0.87c-0.07,0.23-0.21,0.42-0.42,0.55c-0.4,0.25-0.91,0.19-1.23-0.16
		c-0.33-0.36-0.36-0.91-0.06-1.3c0.32-0.41,0.8-0.49,1.33-0.21c0.4-0.4,0.8-0.81,1.21-1.23c-0.1-0.03-0.19-0.01-0.28-0.02
		c-0.09,0-0.18,0-0.28,0c-0.09,0-0.18,0-0.26,0c-0.09,0-0.18,0-0.28,0c0-0.12,0-0.23,0-0.35c0.57,0,1.14,0,1.71,0
		C14.25,10.96,14.25,11.53,14.25,12.12z M15.45,13.75c-0.14,0-0.27,0-0.4,0c0-1.16,0-2.31,0-3.47c0.14,0,0.27,0,0.4,0
		C15.45,11.43,15.45,12.58,15.45,13.75z M17.39,13.79c-0.62-0.58-1.22-1.15-1.84-1.73c0.57-0.61,1.14-1.22,1.72-1.84
		c0.09,0.08,0.18,0.17,0.28,0.25c-0.5,0.51-0.99,1.02-1.49,1.53c0.54,0.5,1.07,1,1.59,1.48C17.57,13.6,17.48,13.7,17.39,13.79z
		 M19.67,13.53c-0.23,0.15-0.48,0.24-0.75,0.25c-0.27,0.02-0.53,0-0.8,0c-0.01,0-0.02-0.01-0.04-0.01
		c-0.01-0.11-0.02-0.23-0.03-0.36c0.07,0,0.12,0.01,0.17,0.01c0.29,0.02,0.58,0.03,0.87-0.04c0.12-0.03,0.23-0.06,0.33-0.13
		c0.25-0.17,0.29-0.52,0.09-0.74c-0.06-0.07-0.14-0.12-0.21-0.17c-0.12-0.07-0.25-0.13-0.37-0.2c-0.13-0.07-0.27-0.15-0.39-0.23
		c-0.54-0.35-0.53-1.14,0.07-1.49c0.16-0.1,0.34-0.14,0.52-0.17c0.27-0.03,0.53-0.02,0.82,0c0.01,0.13,0.02,0.24,0.03,0.36
		c-0.05,0.03-0.11,0.01-0.16,0.01c-0.24-0.02-0.48-0.04-0.72,0.01c-0.1,0.02-0.21,0.06-0.3,0.12c-0.28,0.17-0.31,0.53-0.06,0.74
		c0.1,0.09,0.21,0.15,0.33,0.22c0.14,0.08,0.28,0.15,0.42,0.23c0.08,0.05,0.16,0.1,0.24,0.16C20.21,12.46,20.16,13.19,19.67,13.53z"
		/>
</g>     </svg>
    </SvgIcon>
  )
}
